import {get, post} from './index';

export const getEmployeesBulk = async () => {
  return get('/employeesBulk');
};

export const downloadEmployeesBulkTemplate = async () => {
  return get('/download_employees_bulk_template');
};

export const uploadEmployeesBulk = async (csvData) => {
  return post(`/upload_employees_bulk`, { content: csvData });
};

export const submitEmployeesBulk = async () => {
  return post('/submit_employees_bulk');
};